import React from 'react'

import { rssItems } from 'thewest/routes/static/RSS/data'

import { ConfigurationContext } from 'common/context-providers/configuration-context'
import { RSSList } from './components/RSSList/RSSList'

export const RSS: React.FC = () => (
    <ConfigurationContext.Consumer>
        {config => <RSSList items={rssItems(config.publicUrl)} />}
    </ConfigurationContext.Consumer>
)
